<template>
  <section id="mainContainer">
    <adminHeader></adminHeader>
    <section class="admin-mid-container">
      <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
        <adminNavigation></adminNavigation>
        <section class="admin-right-sidebar">
          <div class="admin-right-sidebar-in">
            <div class="admin-right-sidebar-in-top">
              <div class="admin-custom-row">
                <div class="admin-right-sidebar-in-top-left">
                  <h1>{{ constants.MANAGE_CLIENTS_TEXT }}</h1>
                  <div class="admin-page-type-links">
                    <ul>
                      <li>
                        <a id="allLink" href="#" :class="{ active: activeTab === 'all' }" @click="switchView('all')">
                          {{ constants.ALL_LINK }} <span>{{ counts.all }}</span>
                        </a>
                      </li>
                      <li>
                        <a id="publishedhLink" href="#" :class="{ active: activeTab === 'published' }" @click="switchView('published')">
                          {{ constants.PUBLISHED_LINK }} <span>{{ counts.published }}</span>
                        </a>
                      </li>
                      <li>
                        <a id="unPublishedhLink" href="#" :class="{ active: activeTab === 'unpublished' }" @click="switchView('unpublished')">
                          {{ constants.UNPUBLISHED_LINK }} <span>{{ counts.unpublished }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="admin-right-sidebar-in-top-right">
                  <div class="admin-right-sidebar-in-top-right-top">
                    <div class="admin-search-box">
                      <input id="searchClientInput" type="text" placeholder="Search" v-model="searchedText" @keyup.enter="fetchClients(activeTab), fetchCounts(searchedText)" />
                    </div>
                    <div class="admin-add-btn">
                      <button id="addClientBtn" class="add-btn-admin" :class="{ 'active': showAddForm }" @click="showAddForm = true, selectedClients = [], selectAll = false, cancelEdit()">
                        <i class="add-icon"></i> {{ constants.ADD_CLIENT_BUTTON }}
                      </button>
                    </div>
                  </div>
                  <div class="admin-right-sidebar-in-top-right-btm" v-if="selectedClients.length > 1">
                    <div class="tags">
                      <ul>
                        <li>
                          <span>{{ selectedClients.length }} entries selected</span>
                          <button id="tagCloseBtn" @click="selectedClients = [], selectAll = false"></button>
                        </li>
                      </ul>
                    </div>
                    <div class="delete-all-btn-link">
                      <button class="btn_link" id="deleteAllBtn" data-bs-toggle="modal" data-bs-target="#deletePop" @click="setDeleteMode('all')">
                        {{ constants.DELETE_ALL_BUTTON }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showAddForm" class="white-bg-border add-new-section">
              <div class="add-banner-image-section">
                <h2>{{ constants.ADD_NEW_CLIENT_TEXT }}</h2>
                <div class="add-banner-image-box">
                  <form id="addClientsForm" @submit.prevent="submitForm">
                    <div class="admin-input-field">
                      <label>{{ constants.TITLE_LABEL }}</label>
                      <input id="clientTitleInput" type="text" placeholder="Enter the Title" v-model="newClient.title" />
                      <div class="error-msg" v-if="!newClient.title && errMsg">{{ errMsg }}</div>
                    </div>
                    <div class="admin-input-field">
                      <label>{{ constants.DESCRIPTION_LABEL }}</label>
                      <ckeditor placeholder="Description" class="text-editer" id="clientDescriptionInput" :editor="editor" v-model="newClient.description" :config="editorConfig"></ckeditor>
                      <div class="error-msg" v-if="!newClient.description && errMsg">{{ errMsg }}</div>
                    </div>
                    <div class="admin-input-field">
                      <label>{{ constants.CHALLENGE_LABEL }}</label>
                      <ckeditor placeholder="Challenge" class="text-editer" id="clientChallengeInput" :editor="editor" v-model="newClient.challenge" :config="editorConfig"></ckeditor>
                      <div class="error-msg" v-if="!newClient.challenge && errMsg">{{ errMsg }}</div>
                    </div>
                    <div class="admin-input-field">
                      <label>{{ constants.SOLUTION_LABEL }}</label>
                      <ckeditor placeholder="Solution" class="text-editer" id="clientSolutionInput" :editor="editor" v-model="newClient.solution" :config="editorConfig"></ckeditor>
                      <div class="error-msg" v-if="!newClient.solution && errMsg">{{ errMsg }}</div>
                    </div>
                    <div class="admin-input-field">
                      <label>{{ constants.RESULT_LABEL }}</label>
                      <ckeditor placeholder="Result" class="text-editer" id="clientResultInput" :editor="editor" v-model="newClient.result" :config="editorConfig"></ckeditor>
                      <div class="error-msg" v-if="!newClient.result && errMsg">{{ errMsg }}</div>
                    </div>
                    <div class="admin-custom-row box-row-2">
                      <div class="admin-input-field">
                        <label>{{ constants.IMAGE_LABEL }}</label>
                        <div class="image-upload-input upload-banner-image">
                          <div :class="['image-upload-input-item', { 'uploaded-done': imageUploaded }]">
                            <div class="file-input-box">
                              <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                                @click="clearUploadedImage(false, 'client-image')"></button>
                              <input id="addClientFileInput" type="file" @change="handleFileUpload($event, false)" accept="image/jpeg,image/jpg,image/png" />
                            </div>
                            <div class="image-upload-input-item-in" v-if="!imageUploaded">
                              <div class="image-upload-input-item-icon">
                                <img src="@/assets/images/admin-img/image-icon.svg" alt="" />
                              </div>
                              <span>{{ constants.ADD_IMAGE_LABEL }}</span>
                            </div>
                            <div class="image-upload-input-item-uploaded" v-if="imageUploaded">
                              <img :src="imageUrl" alt="" class="mCS_img_loaded" />
                            </div>
                          </div>
                        </div>
                        <div class="error-msg" v-if="!selectedFile && errMsg">{{ errMsg }}</div>
                      </div>
                      <div class="admin-input-field">
                        <label>{{ constants.LOGO_LABEL }}</label>
                        <div class="image-upload-input upload-banner-image">
                          <div :class="['image-upload-input-item', { 'uploaded-done': logoUploaded }]">
                            <div class="file-input-box">
                              <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                                @click="clearUploadedImage(false, 'client-logo')"></button>
                              <input id="addClientLogoFileInput" type="file" @change="handleLogoUpload($event, false)" accept="image/jpeg,image/jpg,image/png" />
                            </div>
                            <div class="image-upload-input-item-in" v-if="!logoUploaded">
                              <div class="image-upload-input-item-icon">
                                <img src="@/assets/images/admin-img/add_icon.svg" alt="" />
                              </div>
                              <span>{{ constants.ADD_LOGO_LABEL }}</span>
                            </div>
                            <div class="image-upload-input-item-uploaded" v-if="logoUploaded">
                              <img :src="logoUrl" alt="" class="mCS_img_loaded" />
                            </div>
                          </div>
                        </div>
                        <div class="error-msg" v-if="!selectedLogoFile && errMsg">{{ errMsg }}</div>
                      </div>
                    </div>
                    <div class="admin-input-field-submit">
                      <button id="clientSubmitBtn" class="admin-btn-outline-primary add-new-cancel" type="submit" :disabled="isSubmitting">
                        {{ constants.SUBMIT_BUTTON }}
                      </button>
                      <button id="clientCancleBtn" class="admin-btn-outline-secondary add-new-cancel" type="button" @click="resetForm">
                        {{ constants.CANCEL_BUTTON }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div :class="['admin-item-list-section admin-client-section', { 'show-edit-item-outer': editFormSubmitted }]" v-if="editClientsData.length > 0">
              <div class="admin-item-list-section-in" ref="scrollWrapper" data-simplebar>
                <div class="admin-item-list-section-scroll">
                  <div class="admin-item-list-top">
                    <div class="admin-item-list-row">
                      <div class="admin-item-checkbox">
                        <div class="admin-checkbox-input">
                          <input name="cssCheckbox" id="selectAll" type="checkbox" class="css-checkbox" @change="toggleSelectAll" :checked="selectAll === true" />
                          <label for="selectAll"></label>
                        </div>
                      </div>
                      <div class="admin-item-client-title" @click="toggleSort('title')" style="cursor: pointer;">{{ constants.TITLE_LABEL }}
                        <button v-if="sortBy === 'title' || sortBy === '-title'" class="sorting-btn" :class="{ 'sorted': sortBy === '-title' }">
                         </button>
                      
                      </div>
                      <div class="admin-item-client-desc" @click="toggleSort('description')" style="cursor: pointer;">{{ constants.DESCRIPTION_LABEL }}

                        <button v-if="sortBy === 'description' || sortBy === '-description'" class="sorting-btn" :class="{ 'sorted': sortBy === '-description' }">
                        </button>
                       </div>
                      <div class="admin-item-client-Challenge" @click="toggleSort('challenge')" style="cursor: pointer;">{{ constants.CHALLENGE_LABEL }}

                        <button v-if="sortBy === 'challenge' || sortBy === '-challenge'" class="sorting-btn" :class="{ 'sorted': sortBy === '-challenge' }">
                        </button>
                      
                      </div>
                      <div class="admin-item-client-Solution" @click="toggleSort('solution')" style="cursor: pointer;">{{ constants.SOLUTION_LABEL }}
                        <button v-if="sortBy === 'solution' || sortBy === '-solution'" class="sorting-btn" :class="{ 'sorted': sortBy === '-solution' }">
                        </button>
                      </div>
                      <div class="admin-item-banner-image">{{ constants.IMAGE_LABEL }}</div>
                      <div class="admin-item-client-logo">{{ constants.LOGO_LABEL }}</div>
                      <div class="admin-item-actions">{{ constants.ACTIONS_LABEL }}</div>
                      <div class="clear"></div>
                    </div>
                  </div>
                  <div class="admin-item-list-btm">
                    <div ref="sortableList">
                      <div v-for="(client, index) in editClientsData" :key="client.id" :class="['admin-item-box', { 'show-edit-item': client.editing }]">
                        <div class="admin-item-box-top">
                          <div class="admin-item-list-row">
                            <div class="admin-item-checkbox">
                              <div class="admin-checkbox-input">
                                <input name="cssCheckbox" :id="'demo_opt_' + client.id" type="checkbox" class="css-checkbox" @change="toggleClientSelection(client.slug)" :checked="selectedClients.includes(client.slug)" />
                                <label :for="'demo_opt_' + client.id"></label>
                              </div>
                            </div>
                            <div class="admin-item-client-title text-limit">{{ client.title }}</div>
                            <div class="admin-item-client-desc text-limit">{{ useStripHtml(client.description) }}</div>
                            <div class="admin-item-client-Challenge text-limit">{{ useStripHtml(client.challenge) }}</div>
                            <div class="admin-item-client-Solution text-limit">{{ useStripHtml(client.solution) }}</div>
                            <div class="admin-item-banner-image">
                              <div class="admin-item-banner-image-box">
                                <img :src="getCdnImageAddress(client.companyImage, `w_85,h_42/`) || '@/assets/images/admin-img/demo-img/item-img-1.jpg'" alt="" />
                              </div>
                            </div>
                            <div class="admin-item-client-logo">
                              <div class="dmin-item-client-logo-box">
                                <img :src="getCdnImageAddress(client.companyLogo, `w_140,h_38/`) || '@/assets/images/admin-img/demo-img/demo-icon-1.png'" alt="" />
                              </div>
                            </div>
                            <div class="admin-item-actions">
                              <ul class="admin-action-link">
                                <li><button id="clientPgEditBtn" class="editBtn" @click="editClient(index), showAddForm = false">{{ constants.EDIT_BUTTON }}</button></li>
                                <li>
                                  <button id="clientPgDeleteBtn" data-bs-toggle="modal" data-bs-target="#deletePop" @click="setDeleteMode('single', client.slug), showAddForm = false, cancelEdit()">
                                    {{ constants.DELETE_BUTTON }}
                                  </button>
                                </li>
                                <li>
                                  <button id="clientPgUnPublishBtn" class="primary-outline-btn" v-if="client.status === 1" @click="changeClientStatus(client.slug, 0)">
                                    {{ constants.UNPUBLISH_BUTTON }}
                                  </button>
                                  <button id="clientPgPublishBtn" class="primary-outline-btn" v-else-if="client.status === 0" @click="changeClientStatus(client.slug, 1)">
                                    {{ constants.PUBLISH_BUTTON }}
                                  </button>
                                </li>
                              </ul>
                            </div>
                            <div class="clear"></div>
                          </div>
                        </div>
                        <div class="admin-item-box-btm" v-if="client.editing">
                          <div class="add-banner-image-section">
                            <h2>{{ constants.EDIT_CLIENT_TEXT }}</h2>
                            <div class="add-banner-image-box">
                              <div class="admin-input-field">
                                <label>{{ constants.TITLE_LABEL }}</label>
                                <input id="clientTitleInput" type="text" placeholder="Enter the Title" v-model="editClientData.title" />
                                <div class="error-msg" v-if="!editClientData.title && errEditMsg">{{ errEditMsg }}</div>
                              </div>
                              <div class="admin-input-field">
                                <label>{{ constants.DESCRIPTION_LABEL }}</label>
                                <ckeditor placeholder="Description" class="text-editer" id="clientDescriptionInput" :editor="editor" v-model="editClientData.description" :config="editorConfig"></ckeditor>
                                <div class="error-msg" v-if="!editClientData.description && errEditMsg">{{ errEditMsg }}</div>
                              </div>
                              <div class="admin-input-field">
                                <label>{{ constants.CHALLENGE_LABEL }}</label>
                                <ckeditor placeholder="Challenge" class="text-editer" id="clientChallengeInput" :editor="editor" v-model="editClientData.challenge" :config="editorConfig"></ckeditor>
                                <div class="error-msg" v-if="!editClientData.challenge && errEditMsg">{{ errEditMsg }}</div>
                              </div>
                              <div class="admin-input-field">
                                <label>{{ constants.SOLUTION_LABEL }}</label>
                                <ckeditor placeholder="Solution" class="text-editer" id="clientSolutionInput" :editor="editor" v-model="editClientData.solution" :config="editorConfig"></ckeditor>
                                <div class="error-msg" v-if="!editClientData.solution && errEditMsg">{{ errEditMsg }}</div>
                              </div>
                              <div class="admin-input-field">
                                <label>{{ constants.RESULT_LABEL }}</label>
                                <ckeditor placeholder="Result" class="text-editer" id="clientResultInput" :editor="editor" v-model="editClientData.result" :config="editorConfig"></ckeditor>
                                <div class="error-msg" v-if="!editClientData.result && errEditMsg">{{ errEditMsg }}</div>
                              </div>
                              <div class="admin-custom-row box-row-2">
                                <div class="admin-input-field">
                                  <label>{{ constants.IMAGE_LABEL }}</label>
                                  <div class="image-upload-input upload-banner-image">
                                    <div class="image-upload-input-item uploaded-done">
                                      <div class="file-input-box">
                                        <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                                          @click="clearUploadedImage(true, 'client-image')"></button>
                                        <input id="editClientFileInput" type="file" @change="handleFileUpload($event, true)" accept="image/jpeg,image/jpg,image/png" />
                                      </div>
                                      <div class="image-upload-input-item-uploaded">
                                        <img :src="editimageSrc || require('@/assets/images/admin-img/image-icon.svg')" alt="" />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="error-msg" v-if="!editimageSrc && !selectedEditFile">{{ errEditMsg }}</div>
                                </div>
                                <div class="admin-input-field">
                                  <label>{{ constants.LOGO_LABEL }}</label>
                                  <div class="image-upload-input upload-banner-image">
                                    <div class="image-upload-input-item uploaded-done">
                                      <div class="file-input-box">
                                        <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                                            @click="clearUploadedImage(true, 'client-logo')"></button>
                                        <input id="editClientLogoFileInput" type="file" @change="handleLogoUpload($event, true)" accept="image/jpeg,image/jpg,image/png" />
                                      </div>
                                      <div class="image-upload-input-item-uploaded">
                                        <img :src="editLogoSrc || require('@/assets/images/admin-img/image-icon.svg')" alt="" />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="error-msg" v-if="!editLogoSrc && !selectedEditLogoFile">{{ errEditMsg }}</div>
                                </div>
                              </div>
                              <div class="admin-input-field-submit">
                                <button id="clientSubmitBtn" class="admin-btn-outline-primary" @click="submitEditForm(client.slug)" :disabled="isSubmitting">
                                  {{ constants.SUBMIT_BUTTON }}
                                </button>
                                <button id="clientCancleBtn" class="admin-btn-outline-secondary addNewCancel" @click="cancelEdit">
                                  {{ constants.CANCEL_BUTTON }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="admin-pagination-section">
                <div class="custom-row">
                  <div class="item-show-selectbox">
                    <select id="paginationSelectBox" v-model="limit" @change="handleLimitChange">
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                    <span>{{ constants.ENTRIES_PER_PAGE_LABEL }}</span>
                  </div>
                  <div class="admin-pagination" id="paginationBox" v-if="totalPages > 1">
                    <ul>
                      <li v-if="currentPage !== 1" @click="changePage(currentPage - 1)">
                        <a href="#" class="pagination-previous"></a>
                      </li>
                      <li v-for="page in visiblePages" :key="page" @click="changePage(page)" v-if="totalPages != 1">
                        <a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
                      </li>
                      <li v-if="currentPage !== totalPages" @click="changePage(currentPage + 1)">
                        <a href="#" class="pagination-next"></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <p>No data to display</p>
            </div>
          </div>
        </section>
      </div>
    </section>
    <footer class="admin-site-footer">
      <div class="container">{{ constants.COPYRIGHT_TEXT }}</div>
    </footer>
    <div class="modal fade confirmation-popup" id="deletePop" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="confirmation-popup-icon">
            <i><img src="@/assets/images/admin-img/light_delete-outline.svg" alt="" /></i>
          </div>
          <div class="confirmation-popup-mid">
            <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
          </div>
          <div class="confirmation-popup-btm">
            <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal">{{ constants.NO_BUTTON }}</button>
            <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal" @click="confirmDelete">{{ constants.YES_BUTTON }}</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, nextTick } from 'vue';
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import axios from 'axios';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Swal from 'sweetalert2';
import { PageChoices } from '@/enums/PageChoices';
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import { environment } from '@/config/environment';
import { API_BASE_URL } from "@/config/api.config";
import Sortable, { SortableEvent } from 'sortablejs';
import {
  getPaginationLimit,
  setPaginationLimit,
} from "@/utils/paginationUtils";

interface Client {
  id: number;
  title: string;
  description: string;
  challenge: string;
  solution: string;
  result: string;
  companyImage: string;
  companyLogo: string;
  status: number;
  slug: string;
  editing?: boolean;
  Created_at?: string;
  position: number;
}

interface ClientForm {
  title: string;
  description: string;
  challenge: string;
  solution: string;
  result: string;
  companyImage: string;
  companyLogo: string;
  slug?: string; // Optional, not sent in FormData
}

export default defineComponent({
  name: "Clients",
  data() {
    return {
      constants,
      editor: ClassicEditor,
      activeTab: 'all',
      imageSrc: '',
      logoSrc: '',
      editimageSrc: '',
      editLogoSrc: '',
      showAddForm: false,
      limit: 10,
      errMsg: '',
      errEditMsg: '',
      searchTempVar: '',
      selectedFile: null as File | null,
      selectedLogoFile: null as File | null,
      selectedEditFile: null as File | null,
      selectedEditLogoFile: null as File | null,
      imageUploaded: false,
      logoUploaded: false,
      selectAll: false,
      editFormSubmitted: false,
      clients: [] as Client[],
      editClientsData: [] as Client[],
      selectedClients: [] as string[],
      totalPages: 0,
      currentPage: 1,
      searchedText: '',
      editorConfig: {
        toolbar: {
          items: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'undo', 'redo', '|', 'insertTable']
        }
      },
      counts: {
        all: 0,
        published: 0,
        unpublished: 0
      } as any,
      newClient: {
        title: '',
        description: '',
        challenge: '',
        solution: '',
        result: '',
        companyImage: '',
        companyLogo: ''
      } as ClientForm,
      editClientData: {
        title: '',
        description: '',
        challenge: '',
        solution: '',
        result: '',
        companyImage: '',
        companyLogo: '',
        slug: ''
      } as ClientForm,
      clientToDelete: null as string | null, // Changed to string for slug
      deleteMode: 'all' as 'all' | 'single',
      pageChoices: PageChoices,
      isSubmitting: false,
      isDragging: false,
      sortableInstance: null as Sortable | null,
      sortBy: '-position' as string,
    };
  },
  beforeRouteEnter(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn !== "true") {
      next({ name: 'Login' });
    } else {
      next();
    }
  },
  computed: {
    imageUrl(): string {
      return this.imageSrc || require('@/assets/images/admin-img/image-icon.svg');
    },
    editImage(): string {
      return this.editimageSrc || require('@/assets/images/admin-img/image-icon.svg');
    },
    logoUrl(): string {
      return this.logoSrc || require('@/assets/images/admin-img/image-icon.svg');
    },
    editLogo(): string {
      return this.editLogoSrc || require('@/assets/images/admin-img/image-icon.svg');
    },
    visiblePages() {
      const maxVisiblePages = 5;
      const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
      let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
      let end = start + maxVisiblePages - 1;
      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(end - maxVisiblePages + 1, 1);
      }
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  components: {
    adminHeader,
    adminNavigation
  },
  created() {
    this.limit = getPaginationLimit("clients", 10);
    this.fetchCounts();
    this.fetchClients();
  },
  mounted() {
    this.setupSortable();
  },
  methods: {
    setDeleteMode(mode: 'all' | 'single', clientSlug?: string) {
      this.deleteMode = mode;
      if (clientSlug !== undefined) {
        this.clientToDelete = clientSlug;
      }
    },
    async confirmDelete() {
      if (this.deleteMode === 'all') {
        await this.deleteSelectedClients();
      } else if (this.deleteMode === 'single') {
        await this.deleteClient();
      }
    },
    changePage(page: number) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchClients(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        this.selectAll = false;
        this.selectedClients = [];
      }
    },
    handleFileUpload(event: any, isEdit: boolean = false) {
      const target = event.target as HTMLInputElement;
      if (target && target.files && target.files.length > 0) {
        const file = target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          if (e.target && typeof e.target.result === 'string') {
            if (isEdit) {
              this.editimageSrc = e.target.result;
              this.selectedEditFile = file;
            } else {
              this.imageSrc = e.target.result;
              this.selectedFile = file;
              this.imageUploaded = true;
            }
          }
        };
      }
    },
    handleLogoUpload(event: any, isEdit: boolean = false) {
      const target = event.target as HTMLInputElement;
      if (target && target.files && target.files.length > 0) {
        const file = target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          if (e.target && typeof e.target.result === 'string') {
            if (isEdit) {
              this.editLogoSrc = e.target.result;
              this.selectedEditLogoFile = file;
            } else {
              this.logoSrc = e.target.result;
              this.selectedLogoFile = file;
              this.logoUploaded = true;
            }
          }
        };
      }
    },
    toggleClientSelection(clientSlug: string) {
      if (this.selectedClients.includes(clientSlug)) {
        this.selectedClients = this.selectedClients.filter(id => id !== clientSlug);
      } else {
        this.selectedClients.push(clientSlug);
      }
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedClients = [];
        this.selectAll = false;
      } else {
        this.selectedClients = this.editClientsData.map(client => client.slug);
        this.selectAll = true;
      }
    },
    async submitForm() {
      if (!this.newClient.title || !this.newClient.description || !this.newClient.challenge || !this.newClient.solution || !this.newClient.result || !this.selectedFile || !this.selectedLogoFile) {
        this.errMsg = "This Field Is Required";
        return;
      }
      this.isSubmitting = true;
      const formData = new FormData();
      formData.append('title', this.newClient.title);
      formData.append('description', this.newClient.description);
      formData.append('challenge', this.newClient.challenge);
      formData.append('solution', this.newClient.solution);
      formData.append('result', this.newClient.result);
      formData.append('companyImage', this.selectedFile);
      formData.append('companyLogo', this.selectedLogoFile);

      try {
        console.log('Submitting new client:', [...formData.entries()]);
        const response = await axios.post(`${API_BASE_URL}/client/`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        console.log('Create response:', response.data);
        this.resetForm();
        await this.fetchCounts();
        if (this.counts[this.activeTab] > this.limit * this.currentPage) {
          this.currentPage = Math.ceil(this.counts[this.activeTab] / this.limit);
        }
        await this.fetchClients(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        this.imageUploaded = false;
        this.logoUploaded = false;
        Swal.fire({
          icon: 'success',
          title: 'Client Created Successfully!',
          showConfirmButton: false,
          timer: 1500
        });
      } catch (error: any) {
        console.error('Error submitting client:', error);
        Swal.fire({
          icon: 'error',
          title: 'Failed to Create Client',
          text: error.response?.data?.detail || JSON.stringify(error.response?.data) || 'Please try again.',
          showConfirmButton: true
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    async deleteSelectedClients() {
      if (!this.selectedClients.length) {
        Swal.fire({
          icon: 'warning',
          title: 'No Clients Selected',
          showConfirmButton: false,
          timer: 1500
        });
        return;
      }
      try {
        console.log('Deleting clients:', this.selectedClients);
        const response = await axios.delete(`${API_BASE_URL}/client/bulk_delete/`, {
          data: { ids: this.selectedClients }
        });
        console.log('Bulk delete response:', response.data);
        this.editClientsData = this.editClientsData.filter(client => !this.selectedClients.includes(client.slug));
        this.selectedClients = [];
        this.selectAll = false;
        await this.fetchCounts();
        await this.fetchClients(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        if (this.editClientsData.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          await this.fetchClients(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        
      } catch (error: any) {
        console.error('Error deleting clients:', error);
        
      }
    },
    async submitEditForm(clientSlug: string) {
      if (!this.editClientData.title || !this.editClientData.description || !this.editClientData.challenge || !this.editClientData.solution || !this.editClientData.result || (!this.selectedEditFile && !this.editimageSrc) || (!this.selectedEditLogoFile && !this.editLogoSrc)) {
        this.errEditMsg = "This Field Is Required";
        return;
      }
      this.isSubmitting = true;
      const formData = new FormData();
      formData.append('title', this.editClientData.title);
      formData.append('description', this.editClientData.description);
      formData.append('challenge', this.editClientData.challenge);
      formData.append('solution', this.editClientData.solution);
      formData.append('result', this.editClientData.result);
      if (this.selectedEditFile) {
        formData.append('companyImage', this.selectedEditFile);
      }
      if (this.selectedEditLogoFile) {
        formData.append('companyLogo', this.selectedEditLogoFile);
      }
      // Do NOT append slug, let backend generate it
      try {
        console.log('Submitting edit form for slug:', clientSlug);
        console.log('FormData:', [...formData.entries()]);
        const response = await axios.patch(`${API_BASE_URL}/client/${clientSlug}/`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        console.log('Edit response:', response.data);
        await this.fetchClients(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        this.cancelEdit();
        this.editFormSubmitted = false;
        Swal.fire({
          icon: 'success',
          title: 'Client Updated Successfully!',
          showConfirmButton: false,
          timer: 1500
        });
      } catch (error: any) {
        console.error('Error updating client:', error);
        console.log('Error response:', error.response?.data);
        Swal.fire({
          icon: 'error',
          title: 'Failed to Update Client',
          text: error.response?.data?.detail || JSON.stringify(error.response?.data) || 'Please try again.',
          showConfirmButton: true
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    handleLimitChange() {
      setPaginationLimit("clients", this.limit);
      this.currentPage = 1;
      this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
      this.selectAll = false;
      this.selectedClients = [];
      this.fetchClients(this.activeTab, this.limit, 0);
    },
    //@ts-expect-error
    async fetchClients(status = 'all', limit?: number, skip = 0, sortBy = this.sortBy) {
      const effectiveLimit = limit ?? this.limit;
      let url = `${API_BASE_URL}/client/`;
      const params = new URLSearchParams();
      if (status === 'published') params.append('status', '1');
      else if (status === 'unpublished') params.append('status', '0');
      if (this.searchedText && !this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = this.searchedText;
      }
      if (!this.searchedText && this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = '';
      }
      params.append('limit', effectiveLimit.toString());
      params.append('skip', skip.toString());
      if (this.searchedText) {
        params.append('searchedText', this.searchedText);
      }
      params.append('sort_by', sortBy);
      try {
        console.log('Fetching clients with params:', params.toString());
        const response = await axios.get(`${url}?${params.toString()}`);
        this.editClientsData = response.data;
        this.totalPages = Math.ceil(this.counts[status] / effectiveLimit);
        console.log('Clients fetched:', this.editClientsData.length, 'Total pages:', this.totalPages);
        this.setupSortable();
      } catch (error: any) {
        console.error('Error fetching clients:', error);
        Swal.fire({
          icon: 'error',
          title: 'Failed to Fetch Clients',
          text: error.response?.data?.detail || 'Please try again.',
          showConfirmButton: true
        });
      }
    },
    async switchView(status: string) {
      this.currentPage = 1;
      this.activeTab = status;
      this.selectedClients = [];
      this.selectAll = false;
      this.editFormSubmitted = false;
      await this.fetchClients(status, this.limit, 0);
      if (status === 'published') {
        this.totalPages = Math.ceil(this.counts.published / this.limit);
      } else if (status === 'unpublished') {
        this.totalPages = Math.ceil(this.counts.unpublished / this.limit);
      } else {
        this.totalPages = Math.ceil(this.counts.all / this.limit);
      }
    },
    async fetchCounts(searchedText?: string) {
      try {
        const baseUrl = `${API_BASE_URL}/client/count/`;
        const queryParam = searchedText ? `?searchedText=${searchedText}&status=` : '?status=';
        const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
          axios.get(`${baseUrl}${queryParam}0&status=1`),
          axios.get(`${baseUrl}${queryParam}1`),
          axios.get(`${baseUrl}${queryParam}0`)
        ]);
        this.counts = {
          all: allResponse.data.count,
          published: publishedResponse.data.count,
          unpublished: unpublishedResponse.data.count
        };
        if (this.activeTab in this.counts) {
          this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
          console.log('Counts:', this.counts, 'Total pages:', this.totalPages, 'Limit:', this.limit);
        } else {
          console.error(`Invalid active tab: ${this.activeTab}`);
        }
      } catch (error: any) {
        console.error('Error fetching client counts:', error);
        Swal.fire({
          icon: 'error',
          title: 'Failed to Fetch Counts',
          text: error.response?.data?.detail || 'Please try again.',
          showConfirmButton: true
        });
      }
    },
    editClient(index: number) {
      this.editClientsData.forEach((client, i) => {
        client.editing = i === index;
      });
      this.editFormSubmitted = true;
      const selectedClient = this.editClientsData[index];
      this.editClientData = {
        title: selectedClient.title,
        description: selectedClient.description,
        challenge: selectedClient.challenge,
        solution: selectedClient.solution,
        result: selectedClient.result,
        companyImage: selectedClient.companyImage || '',
        companyLogo: selectedClient.companyLogo || '',
        slug: selectedClient.slug // Store slug for PATCH URL
      };
      this.editimageSrc = selectedClient.companyImage
        ? this.getCdnImageAddress(selectedClient.companyImage, 'w_200,h_100/')
        : '';
      this.editLogoSrc = selectedClient.companyLogo
        ? this.getCdnImageAddress(selectedClient.companyLogo, 'w_200,h_100/')
        : '';


      this.selectedEditFile = null;
      this.selectedEditLogoFile = null;
      if (this.sortableInstance) {
        this.sortableInstance.option('disabled', true);
      }
    },
    resetForm() {
      this.newClient = {
        title: '',
        description: '',
        challenge: '',
        solution: '',
        result: '',
        companyImage: '',
        companyLogo: ''
      };
      this.selectedFile = null;
      this.selectedLogoFile = null;
      this.imageSrc = '';
      this.logoSrc = '';
      this.showAddForm = false;
      this.imageUploaded = false;
      this.logoUploaded = false;
      this.errMsg = '';
    },
    cancelEdit() {
      this.editClientsData.forEach((client) => {
        client.editing = false;
      });
      this.editClientData = {
        title: '',
        description: '',
        challenge: '',
        solution: '',
        result: '',
        companyImage: '',
        companyLogo: '',
        slug: ''
      };
      this.editFormSubmitted = false;
      this.selectedEditFile = null;
      this.selectedEditLogoFile = null;
      this.editimageSrc = '';
      this.editLogoSrc = '';
      this.errEditMsg = '';
      if (this.sortableInstance) {
        this.sortableInstance.option('disabled', false);
      }
    },
    async deleteClient() {
      if (!this.clientToDelete) {
        Swal.fire({
          icon: 'warning',
          title: 'No Client Selected',
          showConfirmButton: false,
          timer: 1500
        });
        return;
      }
      try {
        console.log('Deleting client:', this.clientToDelete);
        const response = await axios.delete(`${API_BASE_URL}/client/${this.clientToDelete}/`);
        console.log('Delete response:', response.data);
        await this.fetchCounts();
        await this.fetchClients(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        if (this.editClientsData.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          await this.fetchClients(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        this.clientToDelete = null;
        
      } catch (error: any) {
        console.error('Error deleting client:', error);
        
      }
    },
    async changeClientStatus(clientSlug: string, newStatus: number) {
      try {
        console.log('Changing status for slug:', clientSlug, 'to:', newStatus);
        const formData = new FormData();
        formData.append('status', newStatus.toString());
        const response = await axios.patch(`${API_BASE_URL}/client/${clientSlug}/`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        console.log('Status change response:', response.data);
        await this.fetchCounts();
        await this.fetchClients(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        if (this.editClientsData.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          await this.fetchClients(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        
      } catch (error: any) {
        console.error('Error updating client status:', error);
        
      }
    },
    getCdnImageAddress(src: string, size: string): string {
      if (!src) return '';
      let cdnUrl: string = environment.imageCdn.getHost;
      cdnUrl = cdnUrl.concat(size);
      return cdnUrl + encodeURIComponent(src);
    },
    useStripHtml(html: string) {
      let regex = /(<([^>]+)>)/ig;
      return html.replace(regex, "");
    },
    setupSortable() {
      nextTick(() => {
        const sortableList = this.$refs.sortableList as HTMLElement;
        if (!sortableList) {
          console.error('Sortable list ref not found!');
          return;
        }
        if (this.sortableInstance) {
          this.sortableInstance.destroy();
        }
        this.sortableInstance = Sortable.create(sortableList, {
          animation: 150,
          draggable: '.admin-item-box',
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          dragClass: 'sortable-drag',
          filter: '.css-checkbox, button, input, select, textarea, a, .ck-editor, .ck-content',
          preventOnFilter: true,
          disabled: this.editFormSubmitted,
          onStart: (evt: SortableEvent) => {
            this.isDragging = true;
            if (['title', '-title', 'description', '-description', 'challenge', '-challenge', 'solution', '-solution',].includes(this.sortBy)) {
              evt.preventDefault();
              Swal.fire({
                icon: "warning",
                title: "Cannot Drag",
                text: "First remove sorting then you can be able to drag   it.",
                timer: 2000,
                showConfirmButton: false,
              });
              return false;
            }
          },
          onEnd: async (evt: SortableEvent) => {
            this.isDragging = false;
            const oldIndex = evt.oldIndex!;
            const newIndex = evt.newIndex!;
            if (oldIndex === newIndex) return;
            const newArticlesData = [...this.editClientsData];
            const [movedItem] = newArticlesData.splice(oldIndex, 1);
            newArticlesData.splice(newIndex, 0, movedItem);
            newArticlesData.forEach((item, index) => {
              item.position = index + 1;
            });
            this.editClientsData = newArticlesData;
            const reorderedItems = newArticlesData.map((item) => ({
              id: item.id,
              position: item.position
            }));
            try {
              console.log('Reordering clients:', reorderedItems);
              await axios.post(`${API_BASE_URL}/client/reorder/`, {
                items: reorderedItems
              });
              await this.fetchClients(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
              Swal.fire({
                icon: 'success',
                title: 'Order Updated Successfully!',
                timer: 1500,
                showConfirmButton: false
              });
            } catch (error: any) {
              console.error('Error updating order:', error);
              await this.fetchClients(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
              Swal.fire({
                icon: 'error',
                title: 'Order Update Failed!',
                text: error.response?.data?.detail || 'Reverted to last saved order.',
                showConfirmButton: false,
                timer: 1500
              });
            }
          }
        });
        console.log('Sortable instance created:', this.sortableInstance);
      });
    },

    clearUploadedImage(isEdit: boolean, type: 'client-image' | 'client-logo') {
		if (isEdit) {
            if(type === 'client-image'){
                this.editimageSrc = '';
                this.selectedEditFile = null;
                const fileInput = document.getElementById('editClientFileInput') as HTMLInputElement;
                if (fileInput) {
                    fileInput.value = '';
                }
            }
            else if(type === 'client-logo'){
                this.editLogoSrc = '';
                this.selectedEditLogoFile = null;
                const fileInput = document.getElementById('editClientLogoFileInput') as HTMLInputElement;
                if (fileInput) {
                    fileInput.value = '';
                }
            }
		} else {
            if(type === 'client-image'){
                this.imageSrc = '';
                this.selectedFile = null;
                this.imageUploaded = false;
                const fileInput = document.getElementById('addClientFileInput') as HTMLInputElement;
                if (fileInput) {
                    fileInput.value = '';
                }
            }
            else if(type === 'client-logo'){
                this.logoSrc = '';
                this.selectedLogoFile = null;
                this.logoUploaded = false;
                const fileInput = document.getElementById('addClientLogoFileInput') as HTMLInputElement;
                if (fileInput) {
                    fileInput.value = '';
                }
            }
		}
	},

    toggleSort(field: string) {
            if (this.sortBy === field) {
                this.sortBy = `-${field}`; 
            } else if (this.sortBy === `-${field}`) {
                this.sortBy = '-position'; 
            } else {
                this.sortBy = field; 
            }
            this.fetchClients(this.activeTab, this.limit, (this.currentPage - 1) * this.limit, this.sortBy);
        },

  }
});
</script>

<style scoped>
.admin-item-box-top {
  cursor: move;
}
.admin-item-box.dragging {
  opacity: 0.5;
}
</style>
